import { AuthService } from '../../../authorization/services';
import * as angular from 'angular';
import { IApplicant, ApplicantsService, INote, NotesService, IBlob, ApplicantStatusHistoryService, IApplicantStatusHistory, MasterdataAService } from '../../../services';
import config from '../../../config';

class ApplicantsItemController {

    private applicant: IApplicant;
    private applicantsService: ApplicantsService;
    private activeTabIndex: number;

    private applicantStatusHistoryService: ApplicantStatusHistoryService;
    private applicationStatuses: any;
    private applicationStatusHistories: IApplicantStatusHistory[];

    private notes: INote[];
    private filteredNotes: INote[];
    private notesService: any;
    private currentNote: any;
    private tags: string[];
    private selectedTag: string;

    private files: IBlob[];
    private uploadfile: any;
    users: any;
    archive = false;

    constructor(
        private localStorageService: ng.local.storage.ILocalStorageService,
        ApplicantsService: ApplicantsService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private NotesService: NotesService,
        ApplicantStatusHistoryService: ApplicantStatusHistoryService,
        private AuthService: AuthService,
        private SweetAlert: any,
        private FileSaver: ng.FileSaver,
        private MasterdataAService: MasterdataAService,
        private $filter: any,
    ) {
        'ngInject';

        this.notesService = NotesService;
        this.applicantStatusHistoryService = ApplicantStatusHistoryService;
        this.applicantsService = ApplicantsService;

        angular.element(document).ready(() => {
            (<any>$('#notes-table')).dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }

    public $onInit = () => {
        if(this.$state.current.params.archive){
            this.archive = true;
        }
        
        if (this.$stateParams['tab']) {
            this.activeTabIndex = this.$stateParams['tab'];
        }

        if(this.applicant.userId) {
            var user = this.users.find(u => u.id.toLowerCase() == this.applicant.userId.toLowerCase());
            if(user) {
                this.applicant.userName = user.userName;
            }
        }

        this.getFiles(this.applicant.id);
        this.MasterdataAService.getItems('NoteTags').then(res => {
            this.tags = res;
        });
        
        this.filterNotes();
    }

    submitApplicant() {
        if (this.applicant.id == null) {
            this.saveApplicant();
        } else {
            this.applicantsService.put(this.applicant.id, this.applicant);
        }
    }

    saveApplicant() {
        this.applicantsService.post(this.applicant).then(result => {
            this.$state.go('hr.applicants.item', { 'id': result.id });
        });
    }

    archiveApplicant() {
        this.applicant.inactive = true;
        this.applicantsService.put(this.applicant.id, this.applicant).then(result => {
            this.$state.go('hr.applicants.archiveitem', { 'id': result.id });
        });
    }

    unarchiveApplicant() {
        this.applicant.inactive = false;
        this.applicantsService.put(this.applicant.id, this.applicant).then(result => {
            this.$state.go('hr.applicants.item', { 'id': result.id });
        });
    }

    deleteApplicant() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.applicant.name +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.applicantsService.delete(this.applicant.id);
                this.$state.go('^.list').then(() => { this.$state.reload(); });
            } else {

            }
        });       
    }

    addNoteModal() {
        this.currentNote = null;
        (<any>$('#noteModal')).modal('show');
    }

    updateNoteModal(item) {
        this.currentNote = item;
        (<any>$('#noteModal')).modal('show');
    }

    filterNotes() {
        this.filteredNotes = this.$filter('filter')(this.notes, (note: INote): boolean => {
            if (!!this.selectedTag) {
                return note.tags.indexOf(this.selectedTag) !== -1;
            } else {
                return true;
            }
        });
    }

    submitNote(item) {
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.applicantId = this.applicant.id;

        if (newNote.id == null) {
            this.notesService.post(newNote).then(result => {
                this.notes.push(result);
            });
        } else {
            this.notesService.put(newNote.id, newNote);
        }

        (<any>$('#noteModal')).modal('hide');
    }

    deleteNote(item) {
        this.notes = this.notes.filter(note => note.id !== item.id);

        this.notesService.delete(item.id);
    }

    updateNote(item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    }

    deleteHistory(item) {
        this.applicationStatusHistories = this.applicationStatusHistories.filter(x => x.id !== item.id);

        this.applicantStatusHistoryService.delete(item.id);
    }
    
    updateHistory(item, action) {
        switch (action) {
            case 'delete':
                this.deleteHistory(item);
                break;
        }
    }

    uploadAll() {
        if (this.uploadfile){
            this.postFile(this.applicant.id).then(() => {
                this.$state.go('.', {tab: 1}, {reload: true});
            })
        }
    }

    private postFile = (id) => {
        return this.applicantsService.postBlob(id, this.uploadfile);
    }

    clickUpload() {
        angular.element('#myUploader').trigger('click');
    };
    
    public getFiles = (id) => {
        this.applicantsService.getBlobs(id).then((files) => {
            this.files = files.value;
        })
    }

    public deleteFile = (blobid) => {

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u dit bestand wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.applicantsService.deleteBlob(this.applicant.id, blobid).then((res) => {
                    this.$state.go('.', {tab: 1}, {reload: true});
                })
            } else {

            }
        });       
       
    }

    public downloadFile = (file) => {
        // this.applicantsService.getBlob(this.applicant.id, file.id).then((blob) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    var url = URL.createObjectURL(xhr.response);
                    var aLink = document.createElement('a');
                    document.body.appendChild(aLink);
                    aLink.href = url;
                    aLink.download = file.filenameWithExtention;
                    aLink.click();
                }
            };
    
            var token = this.localStorageService.get("authorizationData");
            
            var url = config.API_URL; 
            xhr.open('GET', url + '/hr/applicant/'+ this.applicant.id +'/blobs/'+ file.id);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            // xhr.setRequestHeader('Dropbox-API-Arg', JSON.stringify({"path": "/"+filename}));
            xhr.send();
        // })
    }  
}

export const applicantsItemComponent = {
    bindings: {
        applicant: '<',
        notes: '<',
        applicationStatusHistories: '<',
        preferredTargetAudiences: '<',
        applicationStatuses: '<',
        functions: '<',
        users: '<'
    },
    controller: ApplicantsItemController,
    template: require('./applicants.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/applicants/applicants.item.component.ts